import React from 'react';
import './AdminFilters.css';

const AdminFilters = ({
  filterStatus,
  setFilterStatus,
  filterType,
  setFilterType,
  filterFacility,
  setFilterFacility,
  searchTerm,
  setSearchTerm,
  dateRange,
  setDateRange,
  sortBy,
  setSortBy,
  facilities,
  filteredCount,
  selectedCount,
  toggleSelectAll,
  totalCount
}) => {
  return (
    <div className="admin-filters">
      <div className="filters-header">
        <h3>
          <i className="fa-solid fa-sliders"></i>
          Filters
        </h3>
        <div className="selection-info">
          <span>{selectedCount} of {filteredCount} selected</span>
          {filteredCount > 0 && (
            <button 
              className="select-all-btn"
              onClick={toggleSelectAll}
            >
              {selectedCount === filteredCount ? 'Deselect All' : 'Select All'}
            </button>
          )}
        </div>
      </div>

      <div className="filters-grid">
        <div className="filter-group">
          <label>
            <i className="fa-solid fa-tag"></i>
            Status
          </label>
          <select 
            value={filterStatus} 
            onChange={(e) => setFilterStatus(e.target.value)}
            className="filter-select"
          >
            <option value="all">All Status</option>
            <option value="pending">Pending</option>
            <option value="approved">Approved</option>
            <option value="rejected">Rejected</option>
            <option value="cancelled">Cancelled</option>
            <option value="waitlist">Waitlist</option>
          </select>
        </div>

        <div className="filter-group">
          <label>
            <i className="fa-solid fa-layer-group"></i>
            Type
          </label>
          <select 
            value={filterType} 
            onChange={(e) => setFilterType(e.target.value)}
            className="filter-select"
          >
            <option value="all">All Types</option>
            <option value="facility">Facility</option>
            <option value="equipment">Equipment</option>
            <option value="membership">Membership</option>
          </select>
        </div>

        <div className="filter-group">
          <label>
            <i className="fa-solid fa-building"></i>
            Facility
          </label>
          <select 
            value={filterFacility} 
            onChange={(e) => setFilterFacility(e.target.value)}
            className="filter-select"
          >
            <option value="all">All Facilities</option>
            {facilities.map(f => (
              <option key={f.id} value={f.id}>{f.name}</option>
            ))}
          </select>
        </div>

        <div className="filter-group">
          <label>
            <i className="fa-solid fa-arrow-up-wide-short"></i>
            Sort By
          </label>
          <select 
            value={sortBy} 
            onChange={(e) => setSortBy(e.target.value)}
            className="filter-select"
          >
            <option value="date_desc">Newest First</option>
            <option value="date_asc">Oldest First</option>
            <option value="name_asc">Name A-Z</option>
            <option value="name_desc">Name Z-A</option>
          </select>
        </div>

        <div className="filter-group search-group">
          <label>
            <i className="fa-solid fa-search"></i>
            Search
          </label>
          <div className="search-input-wrapper">
            <i className="fa-solid fa-search search-icon"></i>
            <input
              type="text"
              placeholder="Search by ID, name, requester..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="search-input"
            />
          </div>
        </div>

        <div className="filter-group">
          <label>
            <i className="fa-regular fa-calendar"></i>
            From Date
          </label>
          <input
            type="date"
            value={dateRange.start}
            onChange={(e) => setDateRange({...dateRange, start: e.target.value})}
            className="date-input"
          />
        </div>

        <div className="filter-group">
          <label>
            <i className="fa-regular fa-calendar"></i>
            To Date
          </label>
          <input
            type="date"
            value={dateRange.end}
            onChange={(e) => setDateRange({...dateRange, end: e.target.value})}
            className="date-input"
          />
        </div>

        <div className="filter-group filter-actions">
          <button 
            className="clear-filters-btn"
            onClick={() => {
              setFilterStatus('all');
              setFilterType('all');
              setFilterFacility('all');
              setSearchTerm('');
              setDateRange({ start: '', end: '' });
              setSortBy('date_desc');
            }}
          >
            <i className="fa-solid fa-rotate"></i>
            Clear Filters
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdminFilters;